import { useEffect } from 'react';
import { useKlydosTopFive } from './useKlydosTopFive';
import useAnalytics from '../../../hooks/useAnalytics';

const DASHBOARD_FIRST_VISIT_KEY = 'klydo_dashboard_first_visited';

export const useDashboard = () => {
  const { data: topKlydos, isLoading: isTopKlydosLoading } = useKlydosTopFive();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    try {
      if (!localStorage.getItem(DASHBOARD_FIRST_VISIT_KEY)) {
        trackEvent({ type: 'dashboard_first_visit' });
        localStorage.setItem(DASHBOARD_FIRST_VISIT_KEY, 'true');
      }
    } catch {
      // localStorage unavailable (e.g. private browsing with storage blocked)
    }
  }, []);

  return {
    topKlydos,
    isTopKlydosLoading,
  };
};
